module.exports = __webpack_public_path__ + "img/ennetix-users-tab4.d2fc7ab0.png";